import type { IconData } from '@stacksjs/iconify-core'

export const logoTwitch1: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M1.52 22.86h1.52v3.04h1.53v1.53h1.52v1.52h3.05v1.53h3.05V32h7.62v-1.52h3.04v-1.53h3.05v-1.52h1.52V25.9h1.53v-3.04h1.52v-3.05H32v-7.62h-1.53V9.14h-1.52V6.09h-1.53V4.57H25.9V3.05h-3.05V1.52h-3.04V0h-7.62v1.52H9.14v1.53H6.09v1.52H4.57v1.52H3.04v3.05H1.52v3.05H0v7.62h1.52ZM6.09 7.62H25.9v10.67h-1.52v1.52h-1.53v1.52h-1.52v1.53h-6.1v1.52h-1.52v1.52h-1.52v1.53H9.14v-3.05H7.61v-3.05H6.09Z\"/><path fill=\"currentColor\" d=\"M24.38 10.67H9.14v12.19h1.52v3.04h1.53v-1.52h1.52v-1.52h1.52v-1.53h6.1v-1.52h1.52v-1.52h1.53Zm-7.62 7.62h-1.53v-6.1h1.53Zm4.57 0h-1.52v-6.1h1.52Z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default logoTwitch1
